import { NavLink } from "react-router-dom";
import React from "react";
import background from "../../statics/img/background.jpg";
import { truncate } from "lodash";

export interface VerticalThumbnailProps {
  cover?: string;
  title: string;
  subtitle?: string;
  link: string;
  image?: string;
}

const VerticalThumbnail = ({
  cover,
  title,
  subtitle,
  link,
  image,
}: VerticalThumbnailProps) => {
  return (
    <NavLink to={link}>
      <div className="w-full space-y-4">
        <div
          className="relative bg-gray-200 bg-center bg-no-repeat bg-cover"
          style={{
            backgroundImage: `url(${image})`,
            paddingTop: "140%",
          }}
        >
          {cover ? (
            <div className="absolute top-0 left-0 w-full h-full">
              <div
                className="absolute top-0 left-0 z-0 w-full h-full bg-center bg-no-repeat bg-cover"
                style={{
                  backgroundImage: `url(${background})`,
                  opacity: image ? "90%" : "100%",
                }}
              ></div>
              <div className="relative z-10 flex items-center justify-center w-full h-full text-2xl font-medium text-white">
                {truncate(cover, { length: 20, omission: "..." })}
              </div>
            </div>
          ) : null}
        </div>

        <div className="space-y-2">
          <div className="font-medium text-cream">
            {truncate(title, { length: 60, omission: "..." })}
          </div>
          {subtitle && (
            <div className="text-xs text-gray-400">
              {truncate(subtitle, { length: 30, omission: "..." })}
            </div>
          )}
        </div>
      </div>
    </NavLink>
  );
};

export default VerticalThumbnail;
